<template>
  <a
    :href="fullLink"
    rel="noopener noreferrer"
    class="invoice-content-delay"
  >
    <img class="delay" src="@/assets/images/delay.svg" alt="delay" />
    <span>{{ delayCount }} {{ description }}</span>
    <img src="@/assets/images/arrow-right-red.svg" alt="right-arrow-red" />
  </a>
</template>
<script setup>
import { ENVIRONMENT_HOSTS } from '@/utils/enum/enviromentHosts';
import { computed } from 'vue';

const TEST_SO_N11 = ENVIRONMENT_HOSTS.TEST_SO_N11;

  const props = defineProps({
    delayCount: {
      type: Number,
      required: false,
    },
    link: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: false,
      default: 'talep için süre azalıyor',
    },
  });

  const fullLink = computed(() => `${TEST_SO_N11}${props.link}`);
</script>

<style lang="scss" scoped>
@import '@/assets/styles/variables.scss';

.invoice-content-delay {
    display: flex !important;
    align-items: center;
    gap: 2px;
    background-color: #FFEFEF;
    border-radius: 4px;
    border: 0.5px solid  #B3BBCB;
    padding: 3px;
    cursor: pointer;

    .delay {
      width: 14.4px;
      height: 14.4px;
    }
    img {
      width: 16px;
      height: 16px;
    }

    span {
      font-size: 11px;
      font-style: normal;
      font-weight: 600;
      line-height: 14px;
      color: #D13333;
    }
  }
</style>